import React from "react";
import { GitHub, Email, Instagram, Facebook, Twitter, LinkedIn } from "@mui/icons-material";
import "./FloatingSocialBar.css";

const ICONS = [
  {
    icon: <GitHub />,
    url: "https://github.com/",
    title: "GitHub",
  },
//   {
//     icon: <Email />,
//     url: "mailto:",
//     title: "Mail",
//   },
  {
    icon: <Instagram />,
    url: "https://instagram.com/",
    title: "Instagram",
  },
  {
    icon: <Facebook />,
    url: "https://facebook.com/",
    title: "Facebook",
  },
  {
    icon: <Twitter />,
    url: "https://twitter.com/",
    title: "Twitter",
  },
  {
    icon: <LinkedIn />,
    url: "https://linkedin.com/",
    title: "LinkedIn",
  },
];

export default function FloatingSocialBar() {
  return (
    <div className="floating-social-bar">
      {ICONS.map(({ icon, url, title }) => (
        <a
          key={title}
          href={url}
          target={url.startsWith("mailto:") ? "_self" : "_blank"}
          rel="noopener noreferrer"
          className="social-icon"
          title={title}
        >
          {icon}
        </a>
      ))}
    </div>
  );
}
